module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/en_6-ed7fdd6056f536ae456571b2abfa76fb.jpg";